import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    administrations: [],
    administration: {},
    totalItems:0,
};

const getters = {
    index: state => administrationId => state.administrations.findIndex(i => i.administrationId === administrationId)
};

const mutations = {
    setAdministrations: (state, r) => (state.administrations = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    add: (state, r) => state.administrations.unshift(r),
    delete: (state, index) => state.administrations.splice(index, 1),
    lock: (state, index) => state.administrations[index].status = status.locked,
    unlock: (state, index) => state.administrations[index].status = status.active,
    setAdministration: (state, r) => (state.administration = r),
    edit: (state, { index, r }) => state.administrations.splice(index, 1, r),

};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.administrations.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setAdministrations", response.data.administrations);
            commit("setTotalItems", response.data.totalItems);

          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.administrations.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.administration);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.administrations.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async lock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.administrations.lock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("lock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async unlock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.administrations.unlock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("unlock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setAdministration", {});
            console.log(id)
            startLoading()
            const response = await dataService.administrations.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setAdministration", response.data.administration);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.administrations.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.administration);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.administrations.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
            showNotification(response.data.message);

            const index = getters.index(id);
            commit("edit", { index, r: response.data.administration });

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    }, 
      async getJobGrades(_, id) {
        try {
            startLoading()
            const response = await dataService.administrations.getJobGrades(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.administration);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async editJobGrades(_, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.administrations.editJobGrades(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
            showNotification(response.data.message);

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
